/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Avatar/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Initials from './Initials/index'
import No from './No/index'
import Picture from './Picture/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Avatar({
  children,
  profile_url,
  initials,
  size = "medium",
  viewPath = "/DesignSystem/Avatar",
  cursor = "pointer",
  backgroundColor,
  borderTopLeftRadius,
  borderTopRightRadius,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  marginTop = 0,
  marginBottom = 0,
  marginRight = 0,
  marginLeft = 0,
  onClick,
  height,
  width
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let avatarProfileUrlValueData = fromData.useDataFormat({ viewPath,
context: 'avatar',
path: 'profile_url',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: avatarProfileUrlValueData,
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxl'
        })
let heightOrdtSpaceL = height ?? dtSpaceL
let widthOrdtSpaceL = width ?? dtSpaceL
let backgroundColorOrdtColorsNeutral200 = backgroundColor ?? dtColorsNeutral200
let borderTopLeftRadiusOrdtSpaceL = borderTopLeftRadius ?? dtSpaceL
let borderTopRightRadiusOrdtSpaceL = borderTopRightRadius ?? dtSpaceL
let borderBottomLeftRadiusOrdtSpaceL = borderBottomLeftRadius ?? dtSpaceL
let borderBottomRightRadiusOrdtSpaceL = borderBottomRightRadius ?? dtSpaceL
  return (<React.Fragment
>
<button
  data-testid="Avatar.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bc-2-2ktN6P': backgroundColorOrdtColorsNeutral200,'--btlr-3-2ktN6P': typeof borderTopLeftRadiusOrdtSpaceL === 'number' ? `${borderTopLeftRadiusOrdtSpaceL}px` : borderTopLeftRadiusOrdtSpaceL,'--btrr-4-2ktN6P': typeof borderTopRightRadiusOrdtSpaceL === 'number' ? `${borderTopRightRadiusOrdtSpaceL}px` : borderTopRightRadiusOrdtSpaceL,'--bblr-5-2ktN6P': typeof borderBottomLeftRadiusOrdtSpaceL === 'number' ? `${borderBottomLeftRadiusOrdtSpaceL}px` : borderBottomLeftRadiusOrdtSpaceL,'--bbrr-6-2ktN6P': typeof borderBottomRightRadiusOrdtSpaceL === 'number' ? `${borderBottomRightRadiusOrdtSpaceL}px` : borderBottomRightRadiusOrdtSpaceL,'--mt-7-2ktN6P': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-8-2ktN6P': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--mr-9-2ktN6P': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-10-2ktN6P': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--h-11-2ktN6P': size === "small" ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : size === "large" ? typeof dtSpaceXxl === 'number' ? `${dtSpaceXxl}px` : dtSpaceXxl : typeof heightOrdtSpaceL === 'number' ? `${heightOrdtSpaceL}px` : heightOrdtSpaceL,'--w-12-2ktN6P': size === "small" ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : size === "large" ? typeof dtSpaceXxl === 'number' ? `${dtSpaceXxl}px` : dtSpaceXxl : typeof widthOrdtSpaceL === 'number' ? `${widthOrdtSpaceL}px` : widthOrdtSpaceL,'--c-1-2ktN6P': onClick === undefined ? "default" : cursor}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Picture'}>
<Picture
  viewPath={`${viewPath}/Picture`}
 size={size}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Initials'}>
<Initials
  viewPath={`${viewPath}/Initials`}
 size={size}
/>
</fromFlow.When>
</button>
{children}
</React.Fragment>)
}